import { render, staticRenderFns } from "./GroupLayerElement.vue?vue&type=template&id=2480914a&scoped=true"
import script from "./GroupLayerElement.vue?vue&type=script&lang=ts"
export * from "./GroupLayerElement.vue?vue&type=script&lang=ts"
import style0 from "./GroupLayerElement.vue?vue&type=style&index=0&id=2480914a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2480914a",
  null
  
)

export default component.exports